(function () {
  const PROMO_KEY = 'winnie_twin_sheet_bundle';
  const PARENT_PRODUCT_TITLE = 'Winnie the Pooh Twin Sheet';
  const FREE_PRODUCT_TITLE = 'Winnie the Pooh Twin Sheet Pillowcase';

  const state = {
    syncing: false,
    scheduled: false,
    childVariantId: null,
  };

  function normalize(text) {
    return (text || '').trim().toLowerCase();
  }

  function isTargetTitle(lineItem, targetTitle) {
    return normalize(lineItem?.product_title) === normalize(targetTitle);
  }

  function getAutoBundleQty(items) {
    return items
      .filter((item) => isTargetTitle(item, FREE_PRODUCT_TITLE))
      .filter((item) => item?.properties?._auto_bundle === PROMO_KEY)
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  function getParentQty(items) {
    return items.filter((item) => isTargetTitle(item, PARENT_PRODUCT_TITLE)).reduce((sum, item) => sum + item.quantity, 0);
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  }

  async function resolveChildVariantId(cartItems) {
    if (state.childVariantId) return state.childVariantId;

    const existingChildLine = cartItems.find((item) => isTargetTitle(item, FREE_PRODUCT_TITLE));
    if (existingChildLine?.variant_id) {
      state.childVariantId = existingChildLine.variant_id;
      return state.childVariantId;
    }

    const cacheKey = `auto_bundle_variant_${PROMO_KEY}`;
    const cached = window.sessionStorage?.getItem(cacheKey);
    if (cached && !Number.isNaN(Number(cached))) {
      state.childVariantId = Number(cached);
      return state.childVariantId;
    }

    const productListResponse = await fetch('/products.json?limit=250', { credentials: 'same-origin' });
    if (!productListResponse.ok) throw new Error('Failed to fetch products');

    const payload = await productListResponse.json();
    const matchingProduct = payload?.products?.find(
      (product) => normalize(product?.title) === normalize(FREE_PRODUCT_TITLE)
    );

    const firstVariantId = matchingProduct?.variants?.[0]?.id;
    if (!firstVariantId) throw new Error('Free product variant not found');

    state.childVariantId = Number(firstVariantId);
    window.sessionStorage?.setItem(cacheKey, String(state.childVariantId));
    return state.childVariantId;
  }

  async function addAutoBundleItem(quantity, variantId) {
    if (quantity <= 0) return;

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity,
            properties: {
              _auto_bundle: PROMO_KEY,
            },
          },
        ],
      }),
    });
  }

  async function removeAutoBundleOverflow(items, overflowQty) {
    if (overflowQty <= 0) return;

    let remaining = overflowQty;
    const autoBundleLines = items
      .map((item, index) => ({ item, line: index + 1 }))
      .filter(({ item }) => isTargetTitle(item, FREE_PRODUCT_TITLE))
      .filter(({ item }) => item?.properties?._auto_bundle === PROMO_KEY);

    for (const entry of autoBundleLines) {
      if (remaining <= 0) break;

      const nextQty = Math.max(0, entry.item.quantity - remaining);
      remaining -= entry.item.quantity - nextQty;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: entry.line,
          quantity: nextQty,
        }),
      });
    }
  }

  async function syncBundle() {
    if (state.syncing) return;

    state.syncing = true;
    try {
      const cart = await fetchCart();
      const parentQty = getParentQty(cart.items || []);
      const currentAutoQty = getAutoBundleQty(cart.items || []);

      if (parentQty === currentAutoQty) return;

      const variantId = await resolveChildVariantId(cart.items || []);

      if (parentQty > currentAutoQty) {
        await addAutoBundleItem(parentQty - currentAutoQty, variantId);
      } else {
        await removeAutoBundleOverflow(cart.items || [], currentAutoQty - parentQty);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.cartUpdate) {
        const updatedCart = await fetchCart();
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'auto-bundle',
          cartData: updatedCart,
        });
      }
    } catch (error) {
      console.warn('[auto-bundle] skipped due to non-blocking error:', error?.message || error);
    } finally {
      state.syncing = false;
    }
  }

  function scheduleSync() {
    if (state.scheduled) return;

    state.scheduled = true;
    setTimeout(() => {
      state.scheduled = false;
      syncBundle();
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', scheduleSync);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'auto-bundle') return;
      scheduleSync();
    });
  }
})();